export default function curateURL(url: string = '') {
  let curatedURL = url;

  if (!curatedURL.startsWith('http')) {
    curatedURL = `https://${url}`;
  }

  if (url.endsWith('/')) {
    curatedURL = curatedURL.substring(0, curatedURL.length - 1);
  }

  return curatedURL;
}
